import { Navigate, Outlet, createFileRoute } from '@tanstack/react-router';
import { useAslen, useSettings } from '@aslen/core/hooks';
import { ErrorState, SkeletonRows } from '@/components/ui/display';
import { AppShell } from '@/components/shell/app-shell';
import { QuickActionDrawers } from '@/features/accounting/entity-forms';

/** Authenticated layout: session → company → onboarding guard, then the shell. */
function AppLayout() {
  const { session, authReady, companyId, membershipsLoading, membershipsUnavailable, refreshMemberships } = useAslen();
  const settings = useSettings();
  if (!authReady || membershipsLoading) {
    return (
      <div className="p-6">
        <SkeletonRows rows={10} />
      </div>
    );
  }
  if (!session) return <Navigate to="/login" />;
  // an unreachable server leaves the membership list empty too — without this the
  // owner would be sent to the onboarding wizard because the connection dropped (W-32)
  if (!companyId && membershipsUnavailable) {
    return (
      <div className="flex h-full items-center justify-center p-8">
        <ErrorState className="max-w-[460px]" onRetry={() => void refreshMemberships()} />
      </div>
    );
  }
  if (!companyId) return <Navigate to="/setup" />;
  const onboarding = settings.data?.onboarding as { completed?: boolean } | undefined;
  if (settings.data && onboarding && onboarding.completed === false) return <Navigate to="/setup" />;
  return (
    <AppShell>
      <Outlet />
      <QuickActionDrawers />
    </AppShell>
  );
}

export const Route = createFileRoute('/_app')({ component: AppLayout });
